type UrlParamScalar = string | number | string[] | number[];

export const parseUrlParams = (
  params?: Record<string, UrlParamScalar | undefined>,
) => {
  const encode = (v: string | number) => encodeURIComponent(String(v));

  const parseEntry = ([key, value]: [string, UrlParamScalar]) => {
    const encodedKey = encodeURIComponent(key);
    if (Array.isArray(value)) {
      return value
        .map((v) => `${encodedKey}=${encode(v)}`)
        .join('&');
    }
    return `${encodedKey}=${encode(value)}`;
  };
  return Object.entries(params || {})
    .filter(
      (entry): entry is [string, UrlParamScalar] =>
        entry[1] !== undefined && entry[1] !== null,
    )
    .map(parseEntry)
    .join('&');
};
